import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

import {
    FaEdit,
    FaTrash,
    FaSave,
    FaTimes,
    FaPlus
} from "react-icons/fa";

function AdminCategories() {

    const [categories, setCategories] = useState([]);
    const [search, setSearch] = useState("");

    const [newCategory, setNewCategory] = useState({
        name: "",
        emoji: "",
        description: "",
        status: "Active",
        display_order: 1
    });

    const [editingCategory, setEditingCategory] = useState(null);

    useEffect(() => {
        loadCategories();
    }, []);

    // ===========================
    // LOAD CATEGORIES
    // ===========================

    const loadCategories = () => {

        axios
            .get(`${API_URL}/categories`)
            .then((res) => {

                console.log("Categories:", res.data);

                setCategories(res.data);

            })
            .catch((err) => {

                console.log(err);

            });

    };

    // ===========================
    // ADD CATEGORY
    // ===========================

    const addCategory = () => {

        if (newCategory.name.trim() === "") {

            alert("Category Name is required");

            return;

        }

        axios
            .post(`${API_URL}/categories`, newCategory)
            .then(() => {

                alert("Category Added Successfully");

                setNewCategory({
                    name: "",
                    emoji: "",
                    description: "",
                    status: "Active",
                    display_order: 1
                });

                loadCategories();

            })
            .catch(console.log);

    };

    // ===========================
    // DELETE
    // ===========================

    const deleteCategory = (id) => {

        if (!window.confirm("Delete this category?")) return;

        axios
            .delete(`${API_URL}/categories/${id}`)
            .then(() => {

                alert("Category Deleted");

                loadCategories();

            })
            .catch(console.log);

    };

    // ===========================
    // EDIT
    // ===========================

    const editCategory = (category) => {

        setEditingCategory({ ...category });

    };

    // ===========================
    // INPUT CHANGE
    // ===========================

    const handleEditChange = (e) => {

        setEditingCategory({

            ...editingCategory,

            [e.target.name]: e.target.value

        });

    };

    // ===========================
    // UPDATE
    // ===========================

    const updateCategory = () => {

        axios
            .put(

                `${API_URL}/categories/${editingCategory.id}`,

                editingCategory

            )
            .then(() => {

                alert("Category Updated Successfully");

                setEditingCategory(null);

                loadCategories();

            })
            .catch(console.log);

    };

    return (

        <div className="admin-layout">

            <AdminSidebar />

            <div className="admin-content">

                <h1>Categories Management</h1>

                <input
                    className="admin-search"
                    placeholder="Search Category..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                {/* ADD CATEGORY */}

                <div className="edit-product-box">

                    <h2>Add Category</h2>

                    <input
                        placeholder="Category Name"
                        value={newCategory.name}
                        onChange={(e) =>
                            setNewCategory({
                                ...newCategory,
                                name: e.target.value
                            })
                        }
                    />

                    <input
                        placeholder="Emoji"
                        value={newCategory.emoji}
                        onChange={(e) =>
                            setNewCategory({
                                ...newCategory,
                                emoji: e.target.value
                            })
                        }
                    />

                    <textarea
                        placeholder="Description"
                        value={newCategory.description}
                        onChange={(e) =>
                            setNewCategory({
                                ...newCategory,
                                description: e.target.value
                            })
                        }
                    />

                    <input
                        type="number"
                        placeholder="Display Order"
                        value={newCategory.display_order}
                        onChange={(e) =>
                            setNewCategory({
                                ...newCategory,
                                display_order: e.target.value
                            })
                        }
                    />

                    <select
                        value={newCategory.status}
                        onChange={(e) =>
                            setNewCategory({
                                ...newCategory,
                                status: e.target.value
                            })
                        }
                    >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>

                    <button
                        className="edit-btn"
                        onClick={addCategory}
                    >
                        <FaPlus /> Add Category
                    </button>

                </div>

                {/* EDIT CATEGORY */}

                {

                    editingCategory && (

                        <div className="edit-product-box">

                            <h2>Edit Category</h2>

                            <input
                                name="name"
                                value={editingCategory.name}
                                onChange={handleEditChange}
                            />

                            <input
                                name="emoji"
                                value={editingCategory.emoji}
                                onChange={handleEditChange}
                            />

                            <textarea
                                name="description"
                                value={editingCategory.description}
                                onChange={handleEditChange}
                            />

                            <input
                                type="number"
                                name="display_order"
                                value={editingCategory.display_order}
                                onChange={handleEditChange}
                            />

                            <select
                                name="status"
                                value={editingCategory.status}
                                onChange={handleEditChange}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>

                            <button
                                className="edit-btn"
                                onClick={updateCategory}
                            >
                                <FaSave /> Save
                            </button>

                            <button
                                className="delete-btn"
                                onClick={() => setEditingCategory(null)}
                            >
                                <FaTimes /> Cancel
                            </button>

                        </div>

                    )

                }

                {/* TABLE */}

                <table className="admin-table">

                    <thead>

                        <tr>

                            <th>ID</th>
                            <th>Emoji</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Order</th>
                            <th>Actions</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            categories
                                .filter((item) =>
                                    item.name
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                )
                                .map((item) => (

                                    <tr key={item.id}>

                                        <td>{item.id}</td>

                                        <td style={{ fontSize: "24px" }}>
                                            {item.emoji}
                                        </td>

                                        <td>{item.name}</td>

                                        <td>{item.description}</td>

                                        <td>{item.status}</td>

                                        <td>{item.display_order}</td>

                                        <td>

                                            <button
                                                className="edit-btn"
                                                onClick={() => editCategory(item)}
                                            >
                                                <FaEdit /> Edit
                                            </button>

                                            <button
                                                className="delete-btn"
                                                onClick={() => deleteCategory(item.id)}
                                            >
                                                <FaTrash /> Delete
                                            </button>

                                        </td>

                                    </tr>

                                ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}

export default AdminCategories;